// extracted by mini-css-extract-plugin
export default {"themeBody":"Theme_themeBody__pNgoO","dark":"Theme_dark__acRDq"};